import { PromotionListResponseType } from "@sellar-io/api-v2/types";

type PromotionRewardItem =
  PromotionListResponseType[number]["PromotionRewardItems"][number];

export const sortPromotionRewardItemsBySpendThreshold = ({
  promotionRewardItems,
}: {
  promotionRewardItems: PromotionRewardItem[];
}): PromotionRewardItem[] => {
  return [...promotionRewardItems].sort(
    (a, b) => a.spendThreshold - b.spendThreshold,
  );
};
